import React from "react";
import AvisoSoloLectura from "./AvisoSoloLectura";
import { MENSAJE_SOLO_LECTURA } from "../utilities/permisos";
import ModalValidarPago from "./ModalValidarPago";

const VistaValidarPago = ({
  cargandoReferencias,
  referenciasPendientes,
  alumnoSeleccionado,
  abrirModalValidacion,
  abrirModalComplemento,
  mostrarModalValidacion,
  refSeleccionada,
  folioBanco,
  setFolioBanco,
  setMostrarModalValidacion,
  confirmarValidacionPago,
  bancoSeleccionado,
  setBancoSeleccionado,
  loadingValidacion,
  modoModal,
  cerrarModal,
  cobrarFaltantePinpad,
  cobrarFaltanteTPV,
  calcularFaltante,
  tienePinpad,
  puedeValidar = true,
  soloLectura = false // Administrador: ve los botones de validar, deshabilitados
}) => {
  return (
    <div className="Dashboard-card">
      <h3 style={{ marginBottom: '15px' }}>Validación de Referencias Bancarias (Ventanilla)</h3>
      <AvisoSoloLectura visible={soloLectura} />

      {cargandoReferencias ? (
        <p>Buscando referencias pendientes en el sistema...</p>
      ) : (
        <div style={{ marginTop: '10px' }}>
          {referenciasPendientes.length === 0 ? (
            <div style={{ padding: '20px', backgroundColor: '#f8f9fa', border: '1px solid #ddd', borderRadius: '5px', textAlign: 'center' }}>
              <p style={{ margin: 0, color: '#555' }}>Este alumno no tiene referencias de pago pendientes por validar.</p>
            </div>
          ) : (
            referenciasPendientes.map((ref) => {
              const esParcial = ref.estatus === "PARCIAL";
              const total = parseFloat(ref.importe_total || 0);
              const abonado = parseFloat(ref.abonado || 0);
              const faltante = +(total - abonado).toFixed(2);

              return (
                <div key={ref.id} style={{
                  border: esParcial ? '2px solid #f0ad4e' : '1px solid #ccc',
                  padding: '15px', marginBottom: '15px', borderRadius: '8px',
                  backgroundColor: esParcial ? '#fffdf5' : '#fff',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                }}>
                  {esParcial && (
                    <div style={{
                      marginBottom: '12px', padding: '8px 12px', borderRadius: '4px',
                      backgroundColor: '#fff3cd', border: '1px solid #ffe082',
                      color: '#7a5c00', fontSize: '0.85rem', fontWeight: 'bold'
                    }}>
                      Pago parcial: se abonaron ${abonado.toFixed(2)} de ${total.toFixed(2)}. Falta ${faltante.toFixed(2)}.
                    </div>
                  )}

                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '10px' }}>
                    <div>
                      {ref.exalumno && (
                        <div style={{ fontSize: '1rem', fontWeight: 'bold', color: '#003366', marginBottom: '6px' }}>
                          👤 {ref.exalumno}
                        </div>
                      )}
                      <h4 style={{ margin: '0 0 5px 0', color: '#0056b3' }}>
                        Ref. Banorte: <span style={{ color: '#333' }}>{ref.referencia_banorte || 'N/A'}</span>
                      </h4>
                      <h4 className="titulo-seccion">
                        Ref. BBVA: <span style={{ color: '#333' }}>{ref.referencia_bbva || 'N/A'}</span>
                      </h4>
                      <span style={{ fontSize: '0.9rem', color: '#666' }}>Generada el: {ref.fecha_creacion} a las {ref.hora_creacion}</span>
                    </div>

                    <div style={{ textAlign: 'right', minWidth: '210px' }}>
                      {esParcial ? (
                        <>
                          <div style={{ fontSize: '0.8rem', color: '#777', textDecoration: 'line-through' }}>
                            ${total.toFixed(2)}
                          </div>
                          <h3 style={{ color: '#d9534f', margin: '2px 0 10px 0' }}>
                            Falta ${faltante.toFixed(2)}
                          </h3>
                          {(puedeValidar || soloLectura) && (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                              <button
                                onClick={() => abrirModalComplemento(ref)}
                                disabled={soloLectura || loadingValidacion}
                                title={soloLectura ? MENSAJE_SOLO_LECTURA : undefined}
                                className="btn-select"
                                style={{ fontSize: '0.85rem', padding: '6px 12px', backgroundColor: '#0056b3', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                              >
                                {soloLectura ? "Cobrar faltante" : tienePinpad ? "Cobrar faltante con Pinpad" : "Cobrar faltante con TPV"}
                              </button>
                              <button
                                onClick={() => abrirModalValidacion(ref)}
                                disabled={soloLectura || loadingValidacion}
                                title={soloLectura ? MENSAJE_SOLO_LECTURA : undefined}
                                className="btn-select validar"
                                style={{ fontSize: '0.85rem', padding: '6px 12px' }}
                              >
                                Validar segundo voucher
                              </button>
                            </div>
                          )}
                        </>
                      ) : (
                        <>
                          <h3 style={{ color: '#28a745', margin: '0 0 8px 0' }}>${total.toFixed(2)}</h3>
                          {(puedeValidar || soloLectura) && (
                            <button
                              onClick={() => abrirModalValidacion(ref)}
                              disabled={soloLectura}
                              title={soloLectura ? MENSAJE_SOLO_LECTURA : undefined}
                              className="btn-select validar"
                              style={{ fontSize: '0.9rem', padding: '6px 12px' }}
                            >
                              Validar Voucher
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </div>

                  <div>
                    <strong style={{ fontSize: '0.9rem' }}>Conceptos incluidos:</strong>
                    <ul style={{ margin: '5px 0 0 0', paddingLeft: '20px', fontSize: '0.9rem', color: '#444' }}>
                      {ref.conceptos && ref.conceptos.length > 0 ? (
                        ref.conceptos.map((concepto, index) => (
                          <li key={index}>
                            {concepto.descripcion} <span style={{ color: '#888' }}>(${concepto.precio_unitario})</span>
                          </li>
                        ))
                      ) : (
                        <li>Sin detalle de conceptos.</li>
                      )}
                    </ul>
                  </div>
                </div>
              );
            })
          )}
        </div>
      )}

      <ModalValidarPago
        mostrar={mostrarModalValidacion && !!refSeleccionada}
        onClose={cerrarModal}
        onConfirm={confirmarValidacionPago}
        loading={loadingValidacion}
        datosPago={refSeleccionada ? {
          importe: refSeleccionada.importe_total,
          abonado: refSeleccionada.abonado,
          estatus: refSeleccionada.estatus,
          referenciaBanorte: refSeleccionada.referencia_banorte,
          referenciaBBVA: refSeleccionada.referencia_bbva,
          folioTPV: refSeleccionada.folio_tpv
        } : null}
        bancoSeleccionado={bancoSeleccionado}
        setBancoSeleccionado={setBancoSeleccionado}
        folioBanco={folioBanco}
        setFolioBanco={setFolioBanco}
        modoModal={modoModal}
        tienePinpad={tienePinpad}
        onCobrarPinpad={() => cobrarFaltantePinpad(refSeleccionada)}
        onCobrarTPV={(folio) => cobrarFaltanteTPV(refSeleccionada, folio)}
        faltante={calcularFaltante ? calcularFaltante(refSeleccionada) : 0}
      />
    </div>
  );
};

export default VistaValidarPago;